import { Store } from '@material-ui/icons';

import List from './List2';

export default {
  list: List,
  icon: Store,
};
